<h6 *ngIf="mapSetting == null">Loading...</h6>
<div *ngIf="mapSetting">
  <form #mapSettingsForm="ngForm" class="form-horizontal" autocomplete="off">
    <div class="panel">
      <div class="top-content-border bottom-content-border" style="margin-top: -1px;">
        <perfect-scrollbar [ngStyle]="{'height.px': scrollHeight}">
          <div *ngIf="displayHeading">
            <h3>Map defaults</h3>
          </div>
          <div class="cs-setting-panel">
            <div class="panel-body">
              <div class="form-edit-group col-sm-8">
                <label class="map-edit-label" aria-hidden="true" for="autoZoom">Map zoom :</label>
                <callsmart-inputswitch name="autoZoom" onLabel="Auto" offLabel="Manual"
                  [(ngModel)]="mapSetting.autoZoom"
                  inverseColours="true"
                  (onChange)="onAnyInputSwitchChanged($event)">
                </callsmart-inputswitch>
              </div>
              <div class="form-edit-group col-sm-8">
                <label class="map-edit-label" aria-hidden="true" for="blackAndWhite">Map colour scale : </label>
                <callsmart-inputswitch name="blackAndWhite" onLabel="Light" offLabel="Default"
                  [(ngModel)]="mapSetting.blackAndWhite"
                  inverseColours="true"
                  (onChange)="onAnyInputSwitchChanged($event)">
                </callsmart-inputswitch>
              </div>
              <div class="form-edit-group col-sm-8">
                <label class="map-edit-label" aria-hidden="true" for="clusterPoints">Map cluster points :</label>
                <callsmart-inputswitch name="clusterPoints" onLabel="Standard" offLabel="Cluster"
                  [(ngModel)]="useMapClusterPoints"
                  inverseColours="true"
                  (onChange)="onAnyInputSwitchChanged($event)">
                </callsmart-inputswitch>
              </div>
              <div class="form-edit-group col-sm-8">
                <label class="map-edit-label" aria-hidden="true" for="directRoutes">Map route lines : </label>
                <callsmart-inputswitch name="directRoutes" onLabel="Direct" offLabel="Travel"
                  [(ngModel)]="mapSetting.directRoutes"
                  inverseColours="true"
                  (onChange)="onAnyInputSwitchChanged($event)">
                </callsmart-inputswitch>
              </div>
              <div class="form-edit-group col-sm-8">
                <label class="map-edit-label" aria-hidden="true" for="callerDotIcon">Caller style :</label>
                <callsmart-inputswitch name="callerDotIcon" onLabel="Dot" offLabel="Pin and number"
                  [(ngModel)]="mapSetting.callerDotIcon"
                  inverseColours="true"
                  (onChange)="onAnyInputSwitchChanged($event)">
                </callsmart-inputswitch>
              </div>
              <div class="form-edit-group col-sm-8">
                <label class="map-edit-label" aria-hidden="true" for="visitDotIcon">Visit style : </label>
                <callsmart-inputswitch  name="visitDotIcon" onLabel="Dot" offLabel="Pin and number"
                  [(ngModel)]="mapSetting.visitDotIcon"
                  inverseColours="true"
                  (onChange)="onAnyInputSwitchChanged($event)">
                </callsmart-inputswitch>
              </div>
              <div class="form-edit-group col-sm-8">
                <label class="map-edit-label" aria-hidden="true" for="frequency">Frequency : </label>
                <callsmart-inputswitch name="frequency" onLabel="Show" offLabel="Hide"
                  [(ngModel)]="mapSetting.frequency"
                  inverseColours="true"
                  (onChange)="onAnyInputSwitchChanged($event)">
                </callsmart-inputswitch>
              </div>
            </div>
          </div>
        </perfect-scrollbar>
      </div>
    </div>
  </form>
</div>